exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.standard-list-small-column {\n    width: 10%;\n}\n\n.standard-list-small-column input, \n.standard-big-column .input-group > .form-control {\n    width: 80px;\n}\n\n.standard-big-column .input-group {\n    flex-wrap: nowrap;\n}\n\n.standard-big-column {\n    width: 40%;\n}\n\n.flex-basis-50 {\n    flex-basis: 50%;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/product/product-price/styles/ProductPriceListingStyles.css
// module id = 6159
// module chunks = 0